var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppSupport = function SvgAppSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm0 1C4.48 20 0 15.52 0 10S4.48 0 10 0s10 4.48 10 10-4.48 10-10 10zm-.4-8l.9-.37c-.26-.2-.4-.5-.4-.72 0-1.4 2.85-1.6 2.85-3.82 0-1.26-1.1-2.28-2.9-2.28-1.4 0-2.48.6-3.2 1.5l.75.8c.54-.73 1.24-1.2 2.34-1.2 1.17 0 1.74.6 1.74 1.35 0 1.55-2.68 1.7-2.68 3.6 0 .42.2.83.6 1.2zm.3 2.88c.44 0 .8-.36.8-.8 0-.45-.36-.82-.8-.82-.45 0-.8.37-.8.8 0 .46.35.82.8.82z"
  })));
};
export default SvgAppSupport;